const DEFAULT_FORM_DATA = {
  ip_address: "",
  subnet_mask: "",
  default_gateway: "",
  preferred_dns_server: "",
  alt_dns_server: "",
  wifi_network_name: "",
  wifi_security_key: "",
  wifi_ip_address: "",
  wifi_subnet_mask: "",
  wifi_default_gateway: "",
  wifi_preferred_dns_server: "",
  wifi_alt_dns_server: "",
};

export default DEFAULT_FORM_DATA;
